import styled from "styled-components";

export const AppWrapper = styled.div`
  display: flex;
  height: 100%;
  font-family: "Roboto", sans-serif;
`;
